import { render, staticRenderFns } from "./ProjectAssetReviewsManager.vue?vue&type=template&id=dcb68e30"
import script from "./ProjectAssetReviewsManager.vue?vue&type=script&lang=js"
export * from "./ProjectAssetReviewsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports